import { useContext, useCallback } from 'react';
import BoundaryContext from './context';

/**
 * @ignore
 *
 * Returns utility functions for Boundaries queries.
 *
 * @returns {useBoundary~isInsideBoundary} - Query whether a specific `Boundary` wraps another component.
 * @returns {useBoundary~findNearestBoundary} - Returns, from a list of Boundaries, what is the closest parent.
 */

export default function useBoundary() {
  const {
    chainOfNames
  } = useContext(BoundaryContext) || {
    chainOfNames: []
  };

  /**
   * Query whether a specific `Boundary` wraps another component.
   *
   * @param {string} name - Name of the `Boundary` that you want to know if it wraps the component.
   * @returns {boolean} Returns `true` if there is a `Boundary` in the component chain it wraps, and `false` otherwise.
   */
  const isInsideBoundary = useCallback(name => chainOfNames.includes(name), [chainOfNames]);

  /**
   * Returns, from a list of Boundaries, what is the closest parent.
   *
   * @param {...string} names - A list of `Boundary` names
   * @returns {string} Returns, from the list of names, the one associated with the `Boundary` as the closest parent, or `undefined` if there is none.
   */
  const findNearestBoundary = useCallback(function () {
    for (var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++) {
      names[_key] = arguments[_key];
    }
    return chainOfNames.find(name => names.includes(name));
  }, [chainOfNames]);
  return {
    isInsideBoundary,
    findNearestBoundary
  };
}